import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Center } from '@chakra-ui/react';
import { hasValue } from '@kcast-fe/core';
import { Svg } from '../Svg';
const VARIANT_STYLES = {
    dark: {
        bg: '{colors.textPrimary}',
        color: '{colors.white}',
        borderRadius: '12px'
    },
    darkLight: {
        bg: '{colors.textPrimarySuperLight}',
        color: '{colors.white}',
        borderColor: '{colors.gray_1}',
        borderRadius: '12px'
    },
    light: {
        bg: '{colors.white}',
        color: '{colors.textSecondary}',
        boxShadow: '{shadows.msg_2}',
        borderRadius: '12px'
    },
    whiteTransparent: {
        bg: '{colors.white}',
        color: '{colors.textSecondary}',
        boxShadow: '{shadows.msg_2}',
        borderRadius: '12px',
        opacity: '0.9',
        border: 'thin solid',
        borderColor: '{colors.borderDefault}'
    },
    pink: {
        bg: '{colors.btnPrimary}',
        color: '{colors.white}',
        borderColor: '{colors.btnPrimaryBorder}',
        borderRadius: '12px'
    },
    transparent: {
        bg: 'transparent',
        color: 'inherit',
        borderRadius: '12px'
    }
};
const VARIANT_LABEL_STYLES = {
    dark: {
        bg: '{colors.textPrimary}',
        color: '{colors.white}',
        borderRadius: '120px'
    },
    darkLight: {
        bg: '{colors.textPrimarySuperLight}',
        color: '{colors.white}',
        borderColor: '{colors.grayLight}',
        borderRadius: '120px'
    },
    light: {
        bg: '{colors.white}',
        color: '{colors.textSecondary}',
        boxShadow: '{shadows.msg_2}',
        borderRadius: '120px'
    },
    whiteTransparent: {
        bg: '{colors.white}',
        color: '{colors.textSecondary}',
        boxShadow: '{shadows.msg_2}',
        borderRadius: '120px'
    },
    pink: {
        bg: '{colors.btnPrimary}',
        color: '{colors.white}',
        borderColor: '{colors.btnPrimaryBorder}',
        borderRadius: '120px'
    },
    transparent: {
        bg: 'transparent',
        color: 'inherit',
        borderRadius: '120px'
    }
};
const SIZES_STYLES = {
    small: { w: '24px', h: '24px' },
    normal: { w: '32px', h: '32px' }
};
const SIZES_LABEL_STYLES = {
    small: { minW: '28px', fontSize: '14px' },
    normal: { minW: '28px', fontSize: '14px' }
};
const LABEL_POSITION = {
    'top-right': { top: '-12px', left: '28px' },
    right: { top: '7px', left: 'calc(100% - 8px)' },
    left: { top: '7px', right: 'calc(100% - 8px)' }
};
const EllipseButtonFC = ({ icon, size, label, labelPosition = 'top-right', iconSize, variant, isBordered, isDisabled, isRounded, onClick }) => {
    return (_jsxs(Box, { "data-testid": 'EllipseButton', position: 'relative', children: [_jsx(Center, { border: isBordered ? '4px solid' : 'none', ...VARIANT_STYLES[variant], ...(isRounded ? { borderRadius: '50%' } : {}), children: _jsx(Center, { ...SIZES_STYLES[size], "data-testid": icon, children: _jsx(Svg, { size: iconSize, name: icon, disabled: isDisabled, onClick: onClick }) }) }), hasValue(label) && (_jsx(Box, { position: 'absolute', ...SIZES_LABEL_STYLES[size], ...LABEL_POSITION[labelPosition], onClick: onClick, children: _jsx(Center, { border: '2px solid', p: '0 4px', ...VARIANT_LABEL_STYLES[variant], children: label }) }))] }));
};
export const EllipseButton = EllipseButtonFC;
//# sourceMappingURL=EllipseButton.js.map